import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [token, setToken] = useState(null);

    useEffect(() => {
        // Cargar el estado de autenticación desde el almacenamiento local (si existe)
        const storedRole = localStorage.getItem('userRole');
        const storedToken = localStorage.getItem('token');

        if (storedToken) { //verificamos la existencia del token
            setIsAuthenticated(true);
            setUserRole(storedRole);
            setToken(storedToken);
        }
    }, []);

    const login = (role, token) => {
        setIsAuthenticated(true);
        setUserRole(role);
        setToken(token);

        // Guardar el estado de autenticación en el almacenamiento local
        localStorage.setItem('isAuthenticated', 'true');
        const trimmedRole = role ? role.trim() : null;
        localStorage.setItem('userRole', trimmedRole);
        localStorage.setItem('token', token);
        setUserRole(trimmedRole);
    };

    const logout = () => {
        setIsAuthenticated(false);
        setUserRole(null);
        setToken(null);

        // Eliminar el estado de autenticación del almacenamiento local
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('userRole');
        localStorage.removeItem('token');
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, userRole, login, logout, token }}>
            {children}
        </AuthContext.Provider>
    );
};

